/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Merge_Blocked_NoticeInputs */



/**
* | output |
* | --- |
* | "Both accounts have a VEKN ID, which can't be deleted, so they can't be merged. Remove the duplicate on vekn.net first." |
*
* @param {Vekn_Merge_Blocked_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_blocked_notice = /** @type {((inputs?: Vekn_Merge_Blocked_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Blocked_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les deux comptes ont un ID VEKN, qui ne peut pas être supprimé : ils ne peuvent donc pas être fusionnés. Supprimez d'abord le doublon sur vekn.net.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las dos cuentas tienen un ID VEKN, que no se puede borrar, así que no se pueden fusionar. Elimine primero el duplicado en vekn.net.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As duas contas têm um ID VEKN, que não pode ser excluído, então não podem ser mescladas. Remova primeiro a duplicata na vekn.net.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Entrambi gli account hanno un ID VEKN, che non si può eliminare, quindi non si possono unire. Elimina prima il duplicato su vekn.net.")
	return /** @type {LocalizedString} */ ("Both accounts have a VEKN ID, which can't be deleted, so they can't be merged. Remove the duplicate on vekn.net first.")
});